exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-sm { margin-top: 10px; }\r\n.no-padding { padding: 0; }\r\n.top-adjustment { padding-top: 4px; }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/payment-nsc/payment-nsc.component.css
// module id = ../../../../../src/app/components/payment-nsc/payment-nsc.component.css
// module chunks = 0